import { Box, Lottie } from '@bonanza-social/moonlight';
import { memo, useEffect } from 'react';
import Animated, { LinearTransition } from 'react-native-reanimated';
import { BottomSheetExtendedProps } from '@bonanza-social/navigation';
import {
  StatusBoxesHeader,
  StatusBoxList,
  StatusInstructions,
  StatusResetDisclaimer,
  StatusTitleText,
} from '../../components';
import { useSelector } from '@bonanza-social/toolkit/state';
import { selectStatus } from '../../state';

function StatusBoxes({ close }: BottomSheetExtendedProps) {
  const status = useSelector(selectStatus);

  useEffect(() => {
    if (!status?.pendingRewards.length) {
      close();
    }
  }, [status, close]);

  useEffect(() => {
    Lottie.present({ animation: 'confetti' });
  }, []);

  if (!status || !status.pendingRewards.length) {
    return null;
  }

  return (
    <Box
      alignItems="center"
      gap="space-400"
      minHeight={470}
      width="100%"
      overflow="hidden"
    >
      <StatusTitleText locKey="status_boxes_title" />
      <StatusBoxesHeader
        statusName={status.pendingRewards[0].sourceType}
        pendingRewardsCount={status.pendingRewards.length}
      />
      <StatusBoxList status={status} />
      <Animated.View layout={LinearTransition} style={{ width: '100%' }}>
        <StatusInstructions status={status} />
      </Animated.View>
      <Animated.View layout={LinearTransition} style={{ width: '100%' }}>
        <StatusResetDisclaimer status={status} />
      </Animated.View>
    </Box>
  );
}

export default memo(StatusBoxes);
